import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: Welcome. A short orientation to the sidebar. Started from
 * the lesson page in a new tab; never auto-started. Every step only points at
 * a control, so nothing is opened or changed.
 */
const tour: TutorialDefinition = {
  id: "welcome-to-police-narratives-ai",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Welcome",
  description: "A quick tour of the sidebar and where your reports live.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "welcome-to-police-narratives-ai",
  autoStart: false,
  steps: [
    {
      target: sel("newCaseDropdown"),
      waitFor: sel("newCaseDropdown"),
      title: "New Case",
      content:
        "Every report starts here. The menu offers Record Audio, Upload Files, and Blank Report, plus Checklist if your department has checklist templates.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("preferencesButton"),
      waitFor: sel("preferencesButton"),
      title: "Report Preferences",
      content: "The sliders icon controls how your drafts are written: perspective, date and time format, rank, badge, and templates.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("casesNav"),
      waitFor: sel("casesNav"),
      title: "Cases and Trash",
      content: "Cases is your list of reports. Trash, just below it, holds deleted cases. You can search the list by title or content.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("academyNav"),
      waitFor: sel("academyNav"),
      title: "Academy",
      content: "Lessons on every feature live here. Files, Forms, and Redactions are the other work areas above it.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("settingsButton"),
      waitFor: sel("settingsButton"),
      title: "Settings",
      content:
        "Your name, email, password, plan, and appearance. Settings is about your account; Report Preferences is about your writing.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
